import React, { Component } from "react";
import "./GameTemplate.scss"
import GamePhaser from "../../atoms/GamePhaser/GamePhaser";
import UiGame from "../../atoms/UiGame/UiGame";
import { connect } from "react-redux";
import ModalFinGame from "../ModalFinGame/ModalFinGame";
import { setStateGame } from "../../../state/actions/GameActions";
import Loader from "../../atoms/Loader/Loader";

class GameTemplate extends Component {

    componentDidMount() {
        const { handleStateGame }: any = this.props;
        handleStateGame(true);
    }
    render() {
        var aux: any = this.props;
        var puntos = aux.Game.puntosGame
        var timer = aux.Game.time
        return (
            <div className="GameTemplate" >
                 {aux.Game.stateGame &&<UiGame puntos={puntos} tiempo={timer}/>}
                {aux.Game.stateGame &&<GamePhaser />}
                {!aux.Game.stateGame && <ModalFinGame />}
                {aux.UI.showLoader && <Loader />}
                
            </div>
        )
    }
}

const mapStateToProps = ({ Game, UI }: any) => ({ Game, UI });

const mapDispatchToProps = (dispatch: any) => ({
    handleStateGame(state: boolean) {
        dispatch(setStateGame(state));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GameTemplate);
